<ng-container *ngIf="isLoading$ | async">
</ng-container>
<div class="page-title-area page-title-four">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2> {{'CONTACTUS.CONTACTUS' | translate}} </h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.CONTACTUS' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="container">
    <div class="card-section">
        <div class="card">
            <h3>{{ language == 'en' ? 'Address': 'العنوان' }} </h3>
            <p> {{ language == 'en' ? HospitalContacts?.addressEn : HospitalContacts?.addressAr }} </p>
        </div>
        <div class="card">
            <h3>{{ language == 'en' ? 'Contact': 'تواصل معنا' }}</h3>
            <p> <i class="icofont-ui-message" style="margin: 0px 15px;"></i>{{ HospitalContacts?.email }}</p>
            <!-- <p style="font-weight:700 !important;" *ngIf="language == 'en'"><i class="icofont-ui-call"
                    style="margin: 0px 15px;"></i>{{ HospitalContacts?.phoneNumberEn }}</p>
            <p *ngIf="language == 'ar'" style="font-size: 22px !important;direction: ltr !important;"><i
                    class="icofont-ui-call" style="margin: 0px 15px;"></i>{{HospitalContacts?.phoneNumberAr }}</p> -->
        </div>
        <div class="card">
            <h3>{{ language == 'en' ? 'Social Media': ' منصات التواصل الاجتماعي' }}</h3>
            <div class="social-icons" style="margin-top: 20px;">
                <a [href]="HospitalContacts?.linkedIn" target="LinkedIn">
                    <svg height="40px" width="40px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 382 382" xml:space="preserve">
<path style="fill:#0077B7;" d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
	C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
	H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
	c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
	s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
	c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
	c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
	c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
	L341.91,330.654L341.91,330.654z"/>
</svg>
                </a>
                <a [href]="HospitalContacts?.twitter" target="X">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#000" viewBox="0 0 16 16"
                        class="bi bi-twitter-x">
                        <path
                            d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                    </svg>

                </a>
                <a [href]="HospitalContacts?.youTube" target="YouTube">
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="#FF0000" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M23.5 6.2C23.4 5.8 23.2 5.4 22.9 5.1C22.6 4.8 22.2 4.6 21.8 4.5C20 4 12 4 12 4C12 4 4 4 2.2 4.5C1.8 4.6 1.4 4.8 1.1 5.1C0.8 5.4 0.6 5.8 0.5 6.2C0 8 0 12 0 12C0 12 0 16 0.5 17.8C0.6 18.2 0.8 18.6 1.1 18.9C1.4 19.2 1.8 19.4 2.2 19.5C4 20 12 20 12 20C12 20 20 20 21.8 19.5C22.2 19.4 22.6 19.2 22.9 18.9C23.2 18.6 23.4 18.2 23.5 17.8C24 16 24 12 24 12C24 12 24 8 23.5 6.2ZM9.75 15.5V8.5L15.5 12L9.75 15.5Z" />
                    </svg>

                </a>
            </div>
        </div>
    </div>
</div>

<!-- <div class="location-area">
    <div class="container">
        <div class="row location-wrap text-center">
            <div class="col-sm-4 col-lg-4 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item FbSocialMediaItem" >
                    <li style="list-style: none !important;">
                        <a [href]="HospitalContacts?.faceBook" target="FaceBook">
                            <span  [inlineSVG]="'./assets/media/svg/icons/System/icons8-facebook.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span>
                        </a>
                    </li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-4 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item">
                    <li style="list-style: none !important;"><a [href]="HospitalContacts?.instagram" target="Instagram">
                            <span [inlineSVG]="'./assets/media/svg/icons/System/icons8-instagram.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span></a></li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-4 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item TwSocialMediaItem">
                    <li style="list-style: none !important;">
                        <a [href]="HospitalContacts?.twitter" target="Twitter">
                            <span [inlineSVG]="'./assets/media/svg/icons/System/icons8-twitter.svg'" cacheSVG="true"
                            class="svg-icon svg-icon-3x "></span>
                        </a>
                    </li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item">
                    <li style="list-style: none !important;">
                        <a [href]="HospitalContacts?.snapchat"
                        target="Snapchat"><span [inlineSVG]="'./assets/media/svg/icons/System/icons8-snapchat.svg'" cacheSVG="true"
                        class="svg-icon svg-icon-3x "></span>
                        </a></li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item" >
                    <li style="list-style: none !important;">
                        <a [href]="WhatsAppNo" target="FaceBook">
                            <span  [inlineSVG]="'./assets/media/svg/icons/System/icons8-whatsapp.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span>
                        </a>
                    </li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item">
                    <li style="list-style: none !important;"><a [href]="HospitalContacts?.linkedIn"
                            target="LinkedIn"><span [inlineSVG]="'./assets/media/svg/icons/System/icons8-linkedin.svg'" cacheSVG="true"
                            class="svg-icon svg-icon-3x "></span></a></li>
                </div>
            </div>
            <div class="col-sm-4 col-lg-3 wow animate__animated animate__fadeInUp" style="margin-bottom: 60px;">
                <div class="location-item">
                    <li style="list-style: none !important;"><a [href]="HospitalContacts?.youTube" target="YouTube"><span [inlineSVG]="'./assets/media/svg/icons/System/icons8-youtube.svg'" cacheSVG="true"
                        class="svg-icon svg-icon-3x "></span></a></li>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- <div class="location-area">
    <div class="container">
        <div class="row location-wrap text-center">
            <div class="col-sm-6 col-lg-3">
                <div class="location-item">
                    <span [inlineSVG]="'./assets/media/svg/icons/System/location-map-2956.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span>
                    <h3>{{'CONTACTUS.LOCATION' | translate}}</h3>
                    <p>{{ language == 'en' ? HospitalContacts?.addressEn : HospitalContacts?.addressAr }}</p>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="location-item">
                    <span [inlineSVG]="'./assets/media/svg/icons/System/mail-1008.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span>
                    <h3>{{'CONTACTUS.EMAIL' | translate}}</h3>
                    <ul>
                        <li style="font-size: 20px !important;">{{ HospitalContacts?.email }}</li>
                    </ul>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="location-item">
                    <span [inlineSVG]="'./assets/media/svg/icons/System/phone-6852.svg'" cacheSVG="true"
                                class="svg-icon svg-icon-3x "></span>
                    <h3>{{'CONTACTUS.PHONE' | translate}}</h3>
                    <ul>
                        <li style="font-size: 26px !important;direction: ltr !important;">{{ language == 'en' ? HospitalContacts?.phoneNumberEn : HospitalContacts?.phoneNumberAr }}</li>
                    </ul>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3">
                <div class="location-item">
                    <span [inlineSVG]="'./assets/media/svg/icons/System/icons8-mailbox-80.svg'" cacheSVG="true"
                    class="svg-icon svg-icon-3x "></span>
                    <h3>{{'CONTACTUS.POSTALCODE' | translate}}</h3>
                    <ul>
                        <li style="font-size: 26px !important;">{{ language == 'en' ? HospitalContacts?.postalCodeEn : HospitalContacts?.postalCodeAr }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- <div class="contact-map-area" >
    <div id="map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3023.952663962006!2d46.830732!3d24.758373000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDQ1JzMwLjEiTiA0NsKwNDknNTAuNiJF!5e1!3m2!1sar!2seg!4v1729106471298!5m2!1sar!2seg" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>    </div>
</div> -->
<!-- <section class="drop-area pt-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-7 p-0">
                <div class="drop-item drop-img">
                    <div class="drop-left">
                        <h2>{{'CONTACTUS.DROPYOURMESSAGE' | translate}}</h2>
                        <form id="contactForm">
                            <div class="row">
                                <div class="col-sm-6 col-lg-6">
                                    <div class="form-group">
                                        <input type="text" name="name" class="form-control"
                                            placeholder="{{'CONTACTUS.NAME' | translate}}">
                                    </div>
                                </div>
                                <div class="col-sm-6 col-lg-6">
                                    <div class="form-group">
                                        <input type="email" name="email" class="form-control"
                                            placeholder="{{'CONTACTUS.EMAIL' | translate}}">
                                    </div>
                                </div>
                                <div class="col-sm-6 col-lg-6">
                                    <div class="form-group">
                                        <input type="text" name="phone_number" class="form-control"
                                            placeholder="{{'CONTACTUS.PHONE' | translate}}">
                                    </div>
                                </div>
                                <div class="col-sm-6 col-lg-6">
                                    <div class="form-group">
                                        <input type="text" name="msg_subject" class="form-control"
                                            placeholder="{{'CONTACTUS.SUBJECT' | translate}}">
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-12">
                                    <div class="form-group">
                                        <textarea name="message" class="form-control" cols="30" rows="5"
                                            placeholder="{{'CONTACTUS.MESSAGE' | translate}}"></textarea>
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-12">
                                    <button type="submit" class="drop-btn">{{'CONTACTUS.SEND' | translate}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 p-">
                <div class="speciality-item speciality-right speciality-right-two speciality-right-three">
                    <img src="assets/img/home-two/bg4.jpg" alt="Contact">
                    
                </div>
            </div>
        </div>
    </div>
</section> -->